// extracted by mini-css-extract-plugin
module.exports = {"image":"Container_image__3Iwdo","inner_container":"Container_inner_container__2YVga","back_icon":"Container_back_icon__2qWhg"};